import React, {useState} from 'react'
export default function ABC(){
  const [ABC, setABC] = useState('')
  const [GHI, setGHI] = useState('')
  const [JKL, setJKL] = useState('')
  const DEF = (x) =>{
    const STU = x.match(/([,0-9]*[\.]{0,1}[0-9]{0,2})/)[0]
    let VWX =''
    if(!(STU.includes('.'))){
      if(STU.length>3 && STU.length<7){
          const format = STU.slice(STU.length-3, STU.length)
          VWX=`${format[0]},${format[1]}`
      }else if(STU.length>0 && STU.length< 4){
        VWX=`${STU}.00`
      }else{
        VWX=`0.00`
      }
    }else{
      if(STU.split('.')[1].length!=2){
        VWX=`${STU.split('.')[0]}.${STU.split('.')[1]}0`
        console.log(STU.split('.'))
      }else{
        VWX=STU
      }
    }
    const YZA = VWX.split('.')[0]
    const n1=YZA.split(',')
    let reformat = false
    for(let i1=0; i1<n1.length; i1++){
      if (i1==0&& n1[i1].length<4){
        console.log('')
      }else if(n1[i1].length==3){
        console.log('')
      }else{
        reformat = true
      }
    }
    if(reformat){
      const n2 = YZA.split(',')
      const BCD = (Math.floor(n2.join('').length/3))
      const EFG = (n2.join('')%3)
      const HIJ = []
      for(let i2=0;i2<BCD+1;i2++){
        if(i2 == BCD){
          HIJ.push(n2.join('').slice(n2.join('').length-3, n2.join('').length))
        }else if (i2==0){
          HIJ.push(n2.join('').slice(0, EFG+1))
          HIJ.push(',')
        }else if(i2==1){
          HIJ.push(n2.join('').slice(EFG, EFG+3))
          HIJ.push(',')
        }else{
        HIJ.push(n2.join('').slice(i2*3+EFG+1-3, 3*i2+EFG+1))
        HIJ.push(',')
        }
      }
      HIJ.push('.')
      HIJ.push(VWX.split('.')[1])
      return setABC(HIJ.join(''))
    }else{
       setABC(VWX)
    }
  }
  function MNO(){
    const num =(ABC.split('.')[0]).split(',').join('')
    if (Number(num)>1000000){
     setJKL('Amount must be less than $1,000,000.00')
    }
    if(Number(num)<1){
      setJKL('Amount must be more than $1.00')
    }
  }
  const PQR = (e) => {
    e.preventDefault()
    setJKL('')
    MNO()
    if(!(ABC.includes('.'))){
      setJKL('Last 2digits is required ex.1.00')
    }else if(ABC.split('.')[1].length!=2){
      setJKL('Last 2digits is required ex.1.00')
    }else if(ABC[0]=='0'){
      setJKL('minimum amount is $1.00')
    }else{
      setGHI('You are successfully submitted.')
    }
  }
  return (
    <div>
    <form className='flex-col flex number-input' onSubmit={PQR}>
    <div className='text-xs mb-2'>
    · limit range $1.00 to $1,000,000.00<br/>
    · auto format correction
    </div>
    <label className='text-xs'>Price</label>
    <div className='text-xs flex'>$<input type='text' placeholder='0.00' value={ABC} minlength={0} maxlength={13} className={`${JKL !=''?'border-red-600':'border-gray-950'} w-[120px] text-right border`} onChange={e=> DEF(e.target.value)} /></div>
    {/* ▼ user can get error result while typing */}
    {ABC.length !=0&& !(/\d{1,3}[,\.]?(\d{1,2})$/.test(ABC))?<span className='error-msg'>Input Error.</span>:''}
    {/* ▼ user can get error after submit*/}
    {JKL!=''?<span className='error-msg'>{JKL}</span>:''}
    <button className='primary-btn mt-1 w-fit text-xs' disabled={!(ABC.length>0)}>Submit</button>
    {JKL!=''?'':<span className='text-xs'>{GHI}</span>}
    </form>
    </div>
  )
}
